import { render } from "./TableManagement.vue?vue&type=template&id=5c8eebd4"
import script from "./TableManagement.vue?vue&type=script&lang=js"
export * from "./TableManagement.vue?vue&type=script&lang=js"

const cssModules = script.__cssModules = {}
import style0 from "./TableManagement.vue?vue&type=style&index=0&id=5c8eebd4&lang=scss&module=true"
cssModules["$style"] = style0
script.render = render

export default script